import { axiosInstance } from '@/modules/shared/lib/axios';
import { UserMutationResponse, UserMutationPayload } from './types';

type Props = {
  companyId: string
  payload: UserMutationPayload
}

export function createAdminUser ({ companyId, payload }: Props) {
    const { driverId, ...rest } = payload
    // Serwer (CreateAdminUserRequest) czyta kierowcę z driverEntityId, tak jak edycja.
    const body = { ...rest, driverEntityId: driverId ?? null }
    return axiosInstance.post<UserMutationResponse>(`/config-api/${companyId}/configuration/admin/users`, body);
}
